import React, {Component} from 'react';
import {
	Input,
	FormLabeledItem,
	Button,
	SelectList,
	ItemChooser,
	TextArea,
	FormDataObj,
	ToggleButton, CheckBox
} from '../../../components/FormUI';
import {AppointmentTypeList, ClinicDoctors, StatusSelectList} from '../../../components/DataSelectList'
import User from '../../../api/User';
import DatePicker from 'react-datepicker';
import moment from 'moment';
//import SelectList from '../../components/SelectList';
import IconWithCaption from '../../../components/IconWithCaption';

import 'react-datepicker/dist/react-datepicker.css';
import './../AppointmentView.css';
import './NewAppForm.css';
import Appointment from '../../../api/Appointment';
import BiopedModal, {ActionModal} from '../../../components/BioPedModal';
import AppointmentType from '../../../api/AppointmentType';

import UserMiniForm from '../../Clients/forms/UserMiniForm';
import AppointmentService from '../../../api/services/AppointmentService';
import ClinicPatientList from '../../../components/datalists/ClinicPatientList';
import TimeStepper from '../../../components/TimeStepper';
import {NotificationManager} from 'react-notifications';
import UserAppHistoryView from '../../UserAppHistoryView';
import CalendarView from "../../CalendarView";
import RootModal from "../../../components/RootModal";
import Modals from "../../../components/Modals";


export default class NewAppForm extends Component {
	constructor(props) {
		super(props);
		this.state = props.appointment || {};
		this.form = new FormDataObj(this.state);
		this.errors = {};
		this.handleTimeUpdate = this.handleTimeUpdate.bind(this);
		this.handleDateChange = this.handleDateChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);

		this.handleChooserChange = this.handleChooserChange.bind(this);
		this.handleAppTypeChange = this.handleAppTypeChange.bind(this);

		this.createNewPatient = this.createNewPatient.bind(this);
		this.handleNewPatientCreated = this.handleNewPatientCreated.bind(this);
		//let appTest = new Appointment(this.state);

		//console.log('appTest:', appTest);

		if (this.state.end) {
			let duration = moment.duration(moment(this.state.end).diff(moment(this.state.start))).asMinutes();
			this.state.duration = duration;
		}
	}

	handleFormChange() {
		console.log("Form Change:", arguments);
	}

	handleTimeUpdate(t, targ) {
		let time = moment(t, 'hh:mm a');
		let date = moment(this.state.start);
		date.hours(time.hours()).minutes(time.minutes());

		let o = {};
		o[targ] = date.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);

		this.setState(o);
		//console.log("time From:", t)
	}

	handleDateChange(d) {
		let date = moment(d);
		let start = date.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
		let end = moment(this.state.end).date(date.date()).month(date.month()).year(date.year()).format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);

		this.setState({start: start, end: end});
	}

	handleSubmit() {
		if (this.isSaving) return;
		this.errors = {};
		let form = this.form;
		//console.log("Form Submit:", this.state);
		//console.log("Form:", form);

		let errors = form.getErrorState();
		// console.log("Form Errors:", errors);
		if (errors != null) {

			this.errors = errors;
			this.forceUpdate();
			//this.setState({errors:err});
			return;
		}

		console.log('Form Data:', this.form.data)

		let end = moment(this.state.start).add(this.getDuration(), 'minutes');
		this.form.data.end = end.format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);

		// if(errors.length > 0)return;

		if (!AppointmentService.IsValidAppTime(this.form.data)) {
			this.setState({showWarning: true});
			//NotificationManager.error('This appointment is outside of the selected pedorthists scheduled hours. Please adjust the date and time accordingly.');
			return;
		}

		this.saveApp(form.data);

		/*let appserv = new AppointmentService();

        appserv.createApp(form.data).then((r) => {
            console.log('Appointment Created! ', r);
            this.isSaving = false;
            this.forceUpdate();

            if(this.props.onSave){
                this.props.onSave(r);
            }

        })

        //this.setState({isSaving:true});
        this.isSaving = true;
        this.forceUpdate();*/
	}

	saveApp(app) {
		let appserv = new AppointmentService();

		appserv.createApp(app).then((r) => {
			console.log('Appointment Created! ', r);
			this.isSaving = false;
			this.forceUpdate();

			if (this.props.onSave) {
				this.props.onSave(r);
			}

		})
		//this.setState({isSaving:true});
		this.isSaving = true;
		this.forceUpdate();
	}

	handleWarning(save) {
		if (save) {
			this.saveApp(this.form.data);
		}
		this.setState({showWarning: false});
	}

	handleChooserChange(val) {
		let sel = {};
		let count = 0;
		let oldx = this.oldx;
		this.oldx = val.x;
		//console.log("New Value:", val.x, "  Old Value:", oldx);

		if (val.x === true && oldx === false) {
			this.setState({reminder: {x: true}});
			return;
		}

		for (let p in val) {
			if (val[p] === true) {
				sel[p] = true;
				count++;
			}
		}
		if (count === 0) {
			val.x = true;
			this.setState({reminder: val});
		} else if (count > 1 && sel['x'] === true) {
			val.x = false;
			this.setState({reminder: val});
		}

	}

	handleAppTypeChange(typeId) {
		let appType = AppointmentType.GetById(typeId, this.state.clinicId);// new AppointmentType(this.state.clinicId, typeId);
		//console.log("App Type Selected:", appType)
		//let end = moment(this.state.start).add(appType.duration || 15, 'minutes');
		this.setState({duration: appType.duration});
		this.form.setValue('duration', appType.duration);
	}

	deleteApp = () => {

		return Modals.DeleteAppointmentModal(this.props.appointment, this.props)

		/*const deleteModal = (
			<div className="delete-app button-modal">
				<div className="modal-caption">Are you sure you want to delete this appointment?</div>
				<div className="table hmax layout-fixed button-bar">
					<div>
						<div>
							<Button className="red" caption="Yes" onClick={() => {
								let appSer = new AppointmentService();
								appSer.delete(this.state.appointmentId).then((d) => {
									CalendarView.Refresh();
									if (this.props.onSave) {
										this.props.onSave(d);
									}
								})

								RootModal.CloseModal();
							}}/>
						</div>
						<div>
							<Button caption="No" onClick={() => {
								RootModal.CloseModal()
							}}/>
						</div>
					</div>
				</div>
			</div>
		)

		const deleteSeriesModal = (

			<div className="delete-app button-modal">
				<div className="modal-caption">Would you like to delete to all future recurrences of this appointment, or to this appointment only?</div>
				<div className="table hmax layout-fixed button-bar">
					<div>
						<div>
							<Button className="red" caption="All" onClick={() => {
								let appSer = new AppointmentService();
								appSer.delete(this.state.appointmentId, 'all').then((d) => {
									CalendarView.Refresh();
									if (this.props.onSave) {
										this.props.onSave(d);
									}
								})

								RootModal.CloseModal();
							}}/>
						</div>
						<div>
							<Button caption="This Appointment Only" onClick={() => {
								let appSer = new AppointmentService();
								appSer.delete(this.state.appointmentId, 'single').then((d) => {
									CalendarView.Refresh();
									if (this.props.onSave) {
										this.props.onSave(d);
									}
								})
								RootModal.CloseModal()
							}}/>
						</div>
						<div>
							<Button caption="Cancel" onClick={() => {
								RootModal.CloseModal()
							}}/>
						</div>
					</div>
				</div>
			</div>
		)

		const isRecurring = this.form.getValue('seriesGuid');

		const modalId = RootModal.ShowModal(isRecurring? deleteSeriesModal:deleteModal);*/

		/*let appSer = new AppointmentService();
		appSer.delete(this.props.appointment.appointmentId).then((d) => {
			if(this.props.onSave){
				this.props.onSave(d);
			}
		})*/
	}

	getDuration() {
		return this.state.duration || 15;
	}

	handleDurationChange = (duration) => {
		this.setState({duration: duration});
	}

	createNewPatient(option) {
		console.log("Create New Patient", option);
		let fullName = option.split(' ');

		this.setState({
			showCreatePatient: true, newPatient: {
				firstName: fullName[0] || '',
				lastName: fullName[1] || ''
			}
		})
	}

	handleNewPatientCreated(user) {
		console.log("New PatientCreated:", user);
		this.setState({showCreatePatient: false, clientId: user.clientId, reloadPatientList: true});
	}

	handlePatientSelect = (patient) => {
		console.log("handlePatientSelect:", patient)
		let prefContact = User.GetContact(patient);
		const typecds = {
			'cellPhone': 'SMSM',
			'homePhone': 'PHON',
			'workPhone': 'PHON',
			'email': 'EMAL'
		}

		if (prefContact) {
			let reminder = {notificationValue: prefContact.value, notificationTypeCd: typecds[prefContact.name]}
			this.state.reminders = [reminder];
		} else {
			this.state.reminders = [];
		}

		if (typeof (patient) === 'object') {
			this.setState({client: new User(patient)});
		}

	}

	render() {
		console.log("Form Render:", this.state)
		let app = this.state;
		let form = this.form;

		//app.end = moment(this.state.start).add(this.getDuration(), 'minutes').format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);

		form.data = app;

		let patient = this.state.client || {};
		//this.form = form;
		let hours = [];
		let mt = moment();
		let appStart = moment(app.start).format('hh:mm a');
		let appEnd = moment(app.end).format('hh:mm a');
		let showNotes = (app.comment || this.openNotes);
		let noteLabel = (showNotes) ? 'Notes' : 'Add Note +';
		let noteStyle = (showNotes) ? {} : {display: 'none'};

		//console.log("Selected Appointment:", app)
		for (let i = 8; i < 20; i++) {
			for (let k = 0; k < 4; k++) {
				let m = moment({hour: i, minute: k * 15});//.hour(i).min(k * 15);
				let label = m.format('hh:mm a');
				hours.push({label: label, value: label})
			}
		}

		let errors = this.errors;
		return (
			<div className="new-app-form">
				<FormLabeledItem label='Client'>
					<ClinicPatientList
						placeholder="Enter Client Name"
						focus={true}
						required
						isCreatable={true}
						name='clientId'
						form={form}
						error={this.errors['clientId']}
						onOptionSelect={this.handlePatientSelect}
					/>
				</FormLabeledItem>
				<FormLabeledItem label='Service'>
					<AppointmentTypeList placeholder="Select Service" required simpleValue={true}
					                     name='appointmentTypeId' form={form} onChange={this.handleAppTypeChange}
					                     error={this.errors['appointmentTypeId']}/>
				</FormLabeledItem>
				<div className="table hmax align-middle">
					<div>
						<div>
							<FormLabeledItem label="Date">
								<DatePicker
									selected={moment(this.state.start)}
									dateFormat="ddd MMM D, YYYY"
									minTime={moment().hours(8).minutes(0)}
									maxTime={moment().hours(19).minutes(0)}
									onChange={this.handleDateChange}
								/>
							</FormLabeledItem>
						</div>
						<div className='time-select-holder'>
							<FormLabeledItem label="From">
								<SelectList options={hours} value={appStart} clearable={false} simpleValue={true}
								            arrowRenderer={null} onChange={(t) => this.handleTimeUpdate(t, 'start')}/>
							</FormLabeledItem>
						</div>
						<div>&nbsp;&nbsp;</div>
						<div className='time-select-holder'>
							<FormLabeledItem label="Duration">
								<TimeStepper min={0} incr={15} onChange={this.handleDurationChange} form={this.form}
								             name='duration'/>
								{/*<SelectList options={hours} value={appEnd} clearable={false} simpleValue={true} arrowRenderer={null} onChange={(t) => this.handleTimeUpdate(t, 'end')} />*/}
							</FormLabeledItem>
						</div>
					</div>
				</div>
				<FormLabeledItem label="Recurrence">
					<Recurrence form={form}/>
				</FormLabeledItem>
				<FormLabeledItem label='Pedorthist'>
					<ClinicDoctors placeholder="Select Pedorthist" clinicId={this.state.clinicId}
					               value={this.state.userId} name='userId' form={form} simpleValue={true} required
					               error={this.errors['userId']}/>
				</FormLabeledItem>
				<div className='table hmax layout-fixed'>
					<div>
						<div>
							<FormLabeledItem label="Status">
								<StatusSelectList name='status' form={form} simpleValue={true} value='Booked'
								                  error={this.errors['status']} required/>
							</FormLabeledItem>
						</div>
						<div className='align-right'>
							<FormLabeledItem label="Reminder" className='inline'>
								<ReminderSelector patient={patient} appointment={app}/>
								{/*<ReminderSelector patient={this.state.patient} />*/}
								{/*<ItemChooser value={this.state.reminder || {'x':true}} onChange={this.handleChooserChange} multi>
                                    <IconWithCaption icon='email' />
                                    <IconWithCaption icon='text' />
                                    <IconWithCaption icon='phone' />
                                    <IconWithCaption icon='x' caption='none' />
                                </ItemChooser> */}
							</FormLabeledItem>
						</div>
					</div>
				</div>
				<CheckBox name={'clientHasRx'} form={form}
				          label={app.clientHasRx ? 'Prescription: Yes' : 'Prescription: No'}
				          onChange={(v) => this.forceUpdate()}/>
				{/*<FormLabeledItem label={app.clientHasRx? 'Prescription: Yes': 'Prescription: No'} >
					<ToggleButton onIcon={'rx'} offIcon={'rx'} toggle={app.clientHasRx} onToggle={(t)=> this.setState({clientHasRx: t}) } />
				</FormLabeledItem>*/}
				<FormLabeledItem label={<span className='add-note-label' onClick={() => {
					this.openNotes = !this.openNotes;
					this.forceUpdate();
				}}>{noteLabel}</span>}>
					<TextArea className='comment' name='comment' form={form} style={noteStyle}/>
				</FormLabeledItem>
				<div className="table hmax layout-fixed button-bar">
					<div>
						<div>{(this.state.client) ? <Button className='white' caption='History'
						                                    onClick={() => this.setState({showHistory: true})}/> : null}</div>
						<div>{(this.state.appointmentId) ?
							<Button className='red' caption='Delete' onClick={this.deleteApp}/> : null}</div>
					</div>
				</div>
				<div className="table hmax layout-fixed button-bar">
					<div>
						<div>&nbsp;</div>
					</div>
					<div>
						<div><Button className='green' caption={this.props.buttonCaption || 'Save'}
						             onClick={this.handleSubmit} isBusy={this.isSaving}/></div>
					</div>
				</div>

				<ActionModal title='New Patient' close='Cancel' isOpen={this.state.showCreatePatient}
				             onRequestClose={() => this.setState({showCreatePatient: false})}>
					<UserMiniForm user={this.state.newPatient} onSaved={this.handleNewPatientCreated}/>
				</ActionModal>

				<BiopedModal isOpen={this.state.showHistory}>
					<UserAppHistoryView className='popup-history' user={this.state.client}
					                    requestClose={() => this.setState({showHistory: false})}/>
				</BiopedModal>

				<BiopedModal isOpen={this.state.showWarning}>
					<div className='app-save-warning'>
						<div className='msg'>This appointment is set outside of the pedorthist hours.<br/>Are you sure
							you want to save?
						</div>
						<div>
							<Button caption='Yes' className='red' onClick={() => this.handleWarning(true)}/> <Button
							className='green' caption='No' onClick={() => this.handleWarning(false)}/>
						</div>
					</div>
				</BiopedModal>

			</div>
		)
	}
}

class ReminderSelector extends Component {
	state = {
		reminders: {}
	};

	form = new FormDataObj();

	contactMatrix = {
		'EMAL': [
			'email'
		],
		'SMSM': [
			'cellPhone',
			'homePhone',
			'workPhone'
		],
		'PHON': [
			'cellPhone',
			'workPhone',
			'homePhone'
		]
	};

	contactDesc = {
		email: 'E',
		cellPhone: 'C',
		homePhone: 'H',
		workPhone: 'W'
	}

	getContactData(cType) {
		console.log("props.patient:", this.props.patient)
		let user = this.props.patient;
		let matrix = this.contactMatrix[cType];
		console.log("MAtrix:", matrix)
		console.log("User:", user)
		let o = {};
		if (matrix === undefined) return o;
		for (let i = 0; i < matrix.length; i++) {
			let p = matrix[i];
			console.log('User[' + p + ']=' + user[p]);
			if (user[p]) {
				o[p] = user[p];
			}
		}

		return o
	}

	getOptions() {
		if (this.props.appointment.client === undefined) return;
		let options = {};
		for (let p in this.contactMatrix) {

			let mItems = this.contactMatrix[p];
			let mValues = [];

			for (let i = 0; i < mItems.length; i++) {
				let pn = mItems[i];
				let desc = this.contactDesc[pn];
				let client = this.props.appointment.client;
				if (client[pn]) {

					mValues.push({label: desc + ':' + client[pn], value: client[pn]})
				}
			}
			options[p] = mValues;
		}

		let reminders = (this.props.appointment || {}).reminders || [];
		for (let i = 0; i < reminders.length; i++) {
			let rmdr = reminders[i];
			let rType = rmdr.notificationTypeCd;
			let rValue = rmdr.notificationValue;
			let opts = options[rType];
			if (!this.isInOptions(rValue, opts) && rValue !== undefined) {
				if (options[rType] === undefined) {
					options[rType] = [];
				}
				options[rType].push({label: 'Other: ' + rValue, value: rValue});
			}
		}

		return options;
	}

	isInOptions(value, options) {
		if (options && value !== undefined) {
			for (let i = 0; i < options.length; i++) {
				if (options[i].value === value) return true;
			}
		}

		return false;
	}


	/*handleNewPatientSelect(patient){
		this.patient = patient;
	}

	componentDidUpdate(prevProps, prevState){
		if((prevProps.patient === undefined && this.props.patient) || ((prevProps.patient && this.props.patient) && (prevProps.patient.clientId !== this.props.patient.clientId))){
			this.handleNewPatientSelect(this.props.patient);
		}
	}*/

	handleReminderUpdate = (val) => {
		console.log("Reminder Update:", val)
		let rmVal = {};
		for (let p in val) {
			let itm = val[p];
			rmVal[itm.notificationTypeCd] = true;
		}

		this.props.appointment.reminders = val;

		console.log("Reminder Chooser Value:", rmVal);

		this.setState({reminder: rmVal});
		this.form.setValue('reminders', this.remindersToChooser());

	}

	remindersToChooser() {
		let cval = {};
		let reminders = (this.props.appointment || {}).reminders || [];
		if (reminders.length === 0) return {NONE: true};

		for (let i = 0; i < reminders.length; i++) {
			let rmdr = reminders[i];
			console.log('rmdr:', rmdr)
			let id = rmdr.notificationTypeCd;
			cval[id] = true;
		}
		console.log('reminderToChooser:', cval)
		return cval;
	}

	componentDidUpdate() {
		this.form.setValue('reminders', this.remindersToChooser());
	}


	render() {
		console.log("this.props.appointment:", this.props.appointment)
		let {onChange, ...props} = this.props;

		let reminders = (this.props.appointment || {}).reminders || [];
		return (
			<div className='reminder-selector'>
				<ItemChooser value={this.remindersToChooser()} disabled={true} form={this.form} name='reminders'
				             onClick={(e) => {
					             //e.preventDefault();
					             this.setState({reminderForm: true})
				             }
				             }
				             multi
				>
					<IconWithCaption icon='email' itemId='EMAL'/>
					<IconWithCaption icon='text' itemId='SMSM'/>
					<IconWithCaption icon='phone' itemId='PHON'/>
					<IconWithCaption icon='x' caption='none' itemId='NONE'/>
				</ItemChooser>

				<ActionModal title='Reminder Settings' close='Done' isOpen={this.state.reminderForm}
				             onRequestClose={() => this.setState({reminderForm: false})}>
					<ReminderForm onChange={this.handleReminderUpdate} reminders={reminders}
					              options={this.getOptions()}/>
				</ActionModal>
			</div>
		)
	}
}

export class ReminderForm extends Component {

	remindForms = {
		EMAL: new FormDataObj({notificationTypeCd: 'EMAL'}),
		SMSM: new FormDataObj({notificationTypeCd: 'SMSM'}),
		PHON: new FormDataObj({notificationTypeCd: 'PHON'}),
		NONE: new FormDataObj({notificationTypeCd: 'NONE'}),
	};

	selected = {};


	reset() {
		for (let p in this.remindForms) {
			let form = this.remindForms[p];
			form.data = {notificationTypeCd: p}
		}
	}


	componentDidMount() {
		this.reset();
		let r = this.props.reminders;
		for (let p in r) {
			let rmdr = r[p];
			let cd = rmdr.notificationTypeCd;
			if (cd) {
				let formData = this.remindForms[cd].data;
				for (let l in rmdr) {
					formData[l] = rmdr[l];
				}
				this.remindForms[cd].populateFormItems();
			}
		}
	}


	handleChange = (val) => {
		console.log('Handle Change:', val)
		this.selected = val;
		let reminders = this.getReminders();

		if (this.props.onChange) {
			this.props.onChange(reminders);
		}
	}

	getReminders(checkValues) {
		let reminders = [];

		//console.log("this.selected:", this.selected);

		for (let p in this.selected) {
			if (this.selected[p]) {
				//console.log('this.remindFors[' + p + ']:', this.remindForms[p])
				if (checkValues && !this.remindForms[p].data.notificationValue) {
					continue;
				}
				reminders.push(this.remindForms[p].data);
			}
		}

		if (reminders.length === 0) {
			reminders.push({
				notificationTypeCd: 'NONE'
			})
		}

		return reminders;
	}

	checkReminders() {
		let reminders = this.props.reminders;
		let rem = [];
		for (let i = 0; i < reminders.length; i++) {
			let reminder = reminders[i];
			if (reminder.notificationValue) {
				rem.push(reminder);
			}
		}

		if (rem.length === 0) {
			rem.push({
				notificationTypeCd: 'NONE'
			})
		}

		return rem;
	}

	componentWillUnmount() {
		if (this.props.onChange) {
			this.props.onChange(this.checkReminders());
		}
	}


	render() {
		console.log('props.reminders:', this.props.reminders)
		let reminders = this.props.reminders || [];
		let rmd = {};
		for (let i = 0; i < reminders.length; i++) {
			let reminder = reminders[i];
			rmd[reminder.notificationTypeCd] = true;
		}
		return (
			<div className='reminder-form'>
				<div className='table align-top hmax'>
					<div>
						<div>
							<ItemChooser value={rmd} onChange={this.handleChange} multi>
								<IconWithCaption icon='email' itemId='EMAL'/>
								<IconWithCaption icon='text' itemId='SMSM'/>
								<IconWithCaption icon='phone' itemId='PHON'/>
							</ItemChooser>
						</div>
						<div className='hmax'>
							<ReminderSelectList itemId='EMAL' forms={this.remindForms} disabled={!rmd['EMAL']}
							                    options={this.props.options}/>
							<ReminderSelectList itemId='SMSM' forms={this.remindForms} disabled={!rmd['SMSM']}
							                    options={this.props.options}/>
							<ReminderSelectList itemId='PHON' forms={this.remindForms} disabled={!rmd['PHON']}
							                    options={this.props.options}/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export class ReminderSelectList extends Component {
	render() {
		let options = this.props.options || {};
		return (
			<SelectList isCreatable={true} name='notificationValue' form={this.props.forms[this.props.itemId]}
			            formValueParser={
				            (val) => {
					            return (val) ? val.value : null
				            }
			            }
			            disabled={this.props.disabled}
			            options={options[this.props.itemId]}
			            promptTextCreator={(label) => 'Add New: ' + label}
			/>
		)
	}
}

/**
 *
 * @param recurType
 * @param multi
 * @returns {({rt: string, label: string, value: string}|{rt: string, label: string, value: string}|{rt: string, label: string, value: string})[]}
 */
function getRecurDurations(recurType, multi) {
	const durations = [
		{label: `For ${multi} Week`, value: 'week', rt: 'daily'},
		{label: `For ${multi} Month`, value: 'month', rt: 'daily weekly'},
		{label: `For ${multi} Year`, value: 'year', rt: 'daily weekly monthly'}
	];
	return durations.map((v) => {
		v.label = multi > 1 ? v.label + 's' : v.label;
		return v;
	}).filter((v) => {
		return v.rt.includes(recurType);
	})
}


export class Recurrence extends Component {

	/*
	"recurType": "daily",
    "recurrenceDuration": {
        "Multiplier": 1,
        "DurationType": "Week"
    }

    RecurType: //daily, weekly, monthly
	DurationType: //month, week, year


	 */

	recurUpdate = (v) => {
		console.log('Select Update:', v);
		if(!this.props.form.getValue('recurrenceDuration')){
			this.props.form.setValue('recurrenceDuration',  {
				multiplier: 1,
				durationType: 'week'
			})
		}
		this.forceUpdate();
		//this.setState({recurType: v.value});
	}
	onDurationType = (v) => {
		this.updateRecurrenceDuration('durationType', v);
	}

	onMultiplier = (v) => {
		if (v > 0 && v <= 12) {
			this.updateRecurrenceDuration('multiplier', Number(v));
		}
	}


	updateRecurrenceDuration = (prop, value) => {
		//console.log(`updateRecurrenceDuration: ${prop} -> ${value}`);
		const rd = this.props.form.getValue('recurrenceDuration') || {
			multiplier: 1,
			durationType: 'week'
		};
		rd[prop] = value;
		this.props.form.setValue('recurrenceDuration', rd);
		this.forceUpdate();
	}

	isPartOfSeries = () => {
		return this.props.form.getValue('seriesGuid');
	}

	render() {
		//console.log('Reccur Type:', this.props.form);
		/**
		 * @type FormDataObj
		 */
		const form = this.props.form;
		const rd = form.getValue('recurrenceDuration') || {
			multiplier: 1,
			durationType: 'week'
		};
		const multi = rd['multiplier'];
		const recurType = form.getValue('recurType');
		let durations = getRecurDurations(recurType, multi);


		if (durations.length) {
			if (!durations.find((v) => {
				return v.value === rd.durationType;
			})) {
				rd.durationType = durations[0].value;
			}
		}
		console.log('durations:', durations);
		console.log('RD:', rd);

		if (!rd['durationType']) rd['durationType'] = durations[0].value;
		const enabled = !!recurType;
		const recurTypes = [
			{label: 'None', value: ''},
			{label: 'Daily', value: 'daily'},
			{label: 'Weekly', value: 'weekly'},
			{label: 'Monthly', value: 'monthly'}
		];

		let view = '';

		if(this.isPartOfSeries()) {
			const rt = recurTypes.find((v) => {
				return v.value === recurType;
			})
			view = <div className='recurrence-form'>
				<div>{rt.label}</div>

			</div>
		} else {
			view = <div className='recurrence-form'>
				<SelectList onChange={this.recurUpdate} name={'recurType'} simpleValue={true} form={this.props.form}
				            options={recurTypes}/>
				<SelectList clearable={false} defaultValue={rd.durationType} required={enabled} disabled={!enabled}
				            name={'durationType'} onChange={this.onDurationType} value={rd['durationType']}
				            simpleValue={true} options={durations}/>

				<div className={"multiplier-btns " + (enabled ? '' : 'disabled')}>
					<div className="add" onClick={() => this.onMultiplier(rd.multiplier + 1)}>+</div>
					<div className="minus" onClick={() => this.onMultiplier(rd.multiplier - 1)}>-</div>
				</div>
			</div>
		}


		//const min =
		return (view)
	}
}



// WEBPACK FOOTER //
// ./src/views/Appointments/forms/NewAppForm.js